import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NonNullableFormBuilder, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { TranslocoModule } from '@ngneat/transloco';
import { UntilDestroy } from '@ngneat/until-destroy';
import { SharedModule } from 'primeng/api';
import { MessagesModule } from 'primeng/messages';

import { AutoAcceptCallSchema } from '@pwp-common';

import { provideValidator } from '../../../../common/form/provide-validator';
import { provideValueAccessor } from '../../../../common/form/provide-value-accessor';
import { FormGroupControlValueAccessor } from '../../../generic/abstract-classes/form-group-control-value-accessor';

@UntilDestroy()
@Component({
  selector: 'app-service-command-editor-auto-accept-call',
  standalone: true,
  imports: [CommonModule, MessagesModule, ReactiveFormsModule, SharedModule, TranslocoModule],
  providers: [
    provideValueAccessor(() => ServiceCommandEditorAutoAcceptCallComponent),
    provideValidator(() => ServiceCommandEditorAutoAcceptCallComponent),
  ],
  templateUrl: './service-command-editor-auto-accept-call.component.html',
  styleUrls: ['./service-command-editor-auto-accept-call.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceCommandEditorAutoAcceptCallComponent extends FormGroupControlValueAccessor<unknown, unknown> {
  private readonly fb = inject(NonNullableFormBuilder);

  public readonly form = this.fb.group({
    commandName: [AutoAcceptCallSchema.Defaults.commandName, [Validators.required]],
  });

  public parseValueChange(value: unknown): unknown {
    return value;
  }

  public makeValidationErrors(): ValidationErrors {
    return {
      'service-command-editor-auto-accept-call': this.form.value,
    };
  }
}
